import { render, staticRenderFns } from "./SetUsername.vue?vue&type=template&id=500cbd5b&scoped=true&"
import script from "./SetUsername.vue?vue&type=script&lang=js&"
export * from "./SetUsername.vue?vue&type=script&lang=js&"
import style0 from "./SetUsername.vue?vue&type=style&index=0&id=500cbd5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500cbd5b",
  null
  
)

/* custom blocks */
import block0 from "./SetUsername.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports